<template>
  <v-dialog v-model="dialogAddPosition" persistent max-width="550px">
    <v-card class="pa-5">
        <!-- <v-card-title>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0"></span>
                <h1 class="ra-head-text-bold mb-0" style="color: #333333;">เพิ่มตำแหน่งงาน</h1>
              </v-col>
            </v-row>
            <v-row class="" justify=center>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0">ชื่อตำแหน่งงาน</span>
                <v-combobox
                  v-model="position"
                  :items="selectDataPosition"
                  placeholder="ชื่อตำแหน่ง"
                  item-text="positionName"
                  class="mt-0"
                  outlined
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ตำแหน่งงาน')"
                  @click:clear="position='', getSelectCompany()"
                >
                  <template v-slot:selection="">
                  </template>
                  <template slot="selection" slot-scope="{ item }">
                    <div v-if="item.positionName">
                      <span >{{item.positionName}}</span>
                    </div>
                    <div v-else>
                      <span>{{item}}</span>
                    </div>
                  </template>
                </v-combobox>
                <!-- <v-autocomplete
                  v-model="position"
                  :items="selectDataPosition"
                  item-text="positionName"
                  outlined
                  placeholder="ชื่อตำแหน่ง"
                  no-data-text="ไม่พบข้อมูล"
                  class="mt-0"
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ตำแหน่งงาน')"
                >
                </v-autocomplete> -->
              </v-col>
            </v-row>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0">ระดับตำแหน่งงาน</span>
                <v-autocomplete
                  v-model="positionLevel"
                  :items="selectDataLevel"
                  item-text="positionLvName"
                  item-value="_id"
                  outlined
                  placeholder="ชื่อระดับตำแหน่ง"
                  no-data-text="ไม่พบข้อมูล"
                  class="mt-0"
                  dense
                  color="#333"
                  clearable
                  @keyup="getSelectCompany($event.target.value, 'ระดับตำแหน่ง')"
                >
                <!-- <template v-slot:no-data>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        Press <kbd>enter</kbd> to add a type
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template> -->
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="mb-0">บริษัท</span>
                <v-select
                  v-model="companyName"
                  :items="selectData"
                  item-text="companyFullNameTh"
                  item-value="_id"
                  dense
                  placeholder="ชื่อบริษัท"
                  outlined
                  color="#333"
                  disabled
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -2%;">
          <v-row justify="center">
            <!-- <v-col cols="4">
              <v-btn class="ml-5" color="error" dark outlined @click="deletePosition">ลบตำแหน่งงาน</v-btn>
            </v-col> -->
            <v-col cols="3">
              <v-btn class="mx-5" color="#2BA197" dark outlined @click="dialogAddPosition = false">ยกเลิก</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn class="mr-5" color="#2BA197" dark @click="submitData()">บันทึกตำแหน่งงาน</v-btn>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <!-- <v-btn class="ma-2 sd" color="success" outlined dark @click="dialogManageCompany = false">ปิด</v-btn> -->
          <!-- <v-btn color="blue darken-1" text @click="submitEdit(desserts)">Save</v-btn> -->
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import
{
  // getSelectCompanyEmployee, // เก่า
  // getSelectPositionAll // เก่า
  // editPosition,
  savePosition,
  getSelectPositionNew // ใหม่
} from '@/API/API'
import { EventBus } from '@/EventBus'
// import TableManageCompany from './_tableManageCompany'
import swal from 'sweetalert'
export default {
  components: {
    // TableManageCompany
    // DialogAddAprover
  },
  data () {
    return {
      dialogAddPosition: false,
      chkDisable: false,
      chkDisableApprove: false,
      chkLeaderApprove: false,
      leaderApprove: 'ไม่ต้องการ',
      expand: false,
      titleType: '',
      textTitle: '',
      preName: '',
      itemCompanyName: [],
      itemPositiomName: [],
      selectData: [],
      selectDataLevel: [],
      selectDataPosition: [],
      keywordCompanyName: '',
      keywordPositionName: '',
      keywordPositionNameOld: '',
      employeeId: '',
      propsEmpId: '',
      position: '',
      positionId: '',
      positionLevel: '',
      companyName: '',
      company: '',
      indexPosition: '',
      positionDataAdd: [],
      positionData: [{
        positionName: '',
        companyName: '',
        positionLevel: ''
      }],
      approver: [],
      alertText: {
        'user is already': 'มีการร้องขอรายการนี้ ในระบบแล้ว',
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'chart not found': 'ไม่พบฝ่ายงานที่ต้องการ',
        'user not found': 'ไม่พบผู้ใช้งาน'
      }
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogAddPosition')
  },
  mounted () {
    EventBus.$on('openDialogAddPosition', this.openDialogAddPosition)
  },
  created () {
    // this.initSelectData() // เก่า
    // this.getListPosition() // เก่า
    this.getSelectCompany() // ใหม่
  },
  watch: {
  },
  methods: {
    openDialogAddPosition (value, companyId, companyName, indexI) {
      this.position = ''
      this.positionLevel = ''
      this.dialogAddPosition = value
      this.companyName = companyId
      this.company = companyName
      this.indexPosition = indexI
      this.getSelectCompany()
    },
    openDialogEditPosition (item) {
      this.dialogAddPosition = true
      this.position = item.positionName
      this.companyName = item.companyId
      this.positionId = item._id
      this.positionLevel = item.positionLevelId
      this.getSelectCompany()
    },
    deletePosition () {
      EventBus.$emit('closedialogEditPosition', this.positionId, 'delete')
      this.dialogAddPosition = false
    },
    async getSelectCompany (value, key) {
      // this.loading = true
      var datafilterall = ''
      const token = this.tokenUser
      if (key === 'ตำแหน่งงาน') {
        const obj = {
          positionName: value,
          companyName: '',
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      } else if (key === 'ระดับตำแหน่ง') {
        const obj = {
          positionName: '',
          companyName: '',
          companyId: '',
          positionLevelName: value,
          positionLevel: ''
        }
        datafilterall = obj
      } else {
        var companyNEW = ''
        if (this.company !== null) {
          if (this.company.includes('(')) {
            companyNEW = this.company.split('(', 1)[0]
          } else if (this.company.includes(' (')) {
            companyNEW = this.company.split(' (', 1)[0]
          } else {
            companyNEW = this.company
          }
        } else {
          companyNEW = ''
        }
        const obj = {
          positionName: this.position,
          companyName: companyNEW,
          companyId: '',
          positionLevelName: '',
          positionLevel: ''
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectPositionNew(datafilterall, token)
        if (res.success) {
          if (key === 'ตำแหน่งงาน') {
            this.selectDataPosition = res.position // ตำแหน่งงาน
          } else if (key === 'ระดับตำแหน่ง') {
            this.selectDataLevel = res.positionLevelResult // ระดับตำแหน่ง
          } else {
            this.selectData = res.company // บริษัท
            this.selectDataPosition = res.position // ตำแหน่งงาน
            this.selectDataLevel = res.positionLevelResult // ระดับตำแหน่ง
          }
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        // this.loading = false
      }
    },
    // อันเก่า
    // async getListPosition () {
    //   this.loading = true
    //   this.selectDataPosition = []
    //   const token = this.tokenUser
    //   try {
    //     const res = await getSelectPositionAll(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         for (let index = 0; index < res.result[0].position.length; index++) {
    //           this.selectDataPosition.push(res.result[0].position[index].positionName)
    //         }
    //         this.selectDataLevel = res.result[1].positionLvName
    //       }
    //     } else {
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    // async initSelectData () {
    //   this.loading = true
    //   this.selectData = []
    //   const token = this.tokenUser
    //   try {
    //     const res = await getSelectCompanyEmployee(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         this.selectData = res.result
    //       }
    //     } else {
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //   }
    // },
    // สิ้นสุด
    async submitData () {
      this.propsitems = this.$route.params.item
      this.positionData = [{
        companyName: this.companyName, // id บริษัท
        positionLevel: this.positionLevel, // id ระดับตำแหน่ง
        positionName: typeof this.position === 'object' ? this.position.positionName : this.position// ชื่อตำแหน่ง
      }]
      const obj = this.positionData
      if (this.position === '') {
        swal('คำเตือน', 'กรุณากรอกชื่อตำแหน่งงาน', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        try {
          const res = await savePosition(obj, this.tokenUser)
          this.positionDataAdd = [{
            _id: res.result.insertList[0].companyId,
            positionName: res.result.insertList[0].positionName
          }]
          if (res.success) {
            swal('สำเร็จ', 'เพิ่มตำแหน่งงานสำเร็จ', 'success', {
              button: false,
              timer: 2000
            }).then()
            EventBus.$emit('addPosition', this.positionDataAdd, this.indexPosition)
            this.positionId = ''
            this.positionLevel = ''
            this.position = ''
            this.companyName = ''
            this.dialogAddPosition = false
          } else {
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          }
        } catch (error) {
          console.log(error)
          swal('ผิดพลาด', 'เนื่องจากมีชื่อตำแหน่งงานนี้ในระบบแล้ว', 'error', {
            button: false,
            timer: 3000
          })
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
</style>
